module.exports = __webpack_public_path__ + "img/75576.dc1c2e51.svg";